import React, {ReactElement} from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData, IExchangeProgramNames } from '@components/ssap/SsapTypes';
import classnames from 'classnames';

interface IMedicaidCooperationAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean,
    exchangeAndProgramNames: IExchangeProgramNames
}

const MedicaidCooperationAttestation = (props: IMedicaidCooperationAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                medicaidRequirementAgreementIndicator
            }
        },
        formName,
        exchangeAndProgramNames,
        isAsteriskShown = true
    } = props;

    const { exchangeMedicaid ,exchangeMedicaidOrChip } = exchangeAndProgramNames;

    const className = classnames({
        'required-true': isAsteriskShown
    });

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <span className = { className }>
                            <FormattedMessage 
                                id = 'ssap.input.label.agree_to_cooperate_medicaid' 
                                values = { { exchangeMedicaid, exchangeMedicaidOrChip } }
                            />
                        </span>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'medicaidRequirementAgreementIndicator',
                classes: [ 'disp-styl' ],
                checked: medicaidRequirementAgreementIndicator,
                value: medicaidRequirementAgreementIndicator,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default MedicaidCooperationAttestation;